import { Injectable } from '@angular/core';
import { ConnectionStatus, Network } from '@capacitor/network';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { LoggerService } from './logger.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class ConnectivityService {
  _networkStatus: Subject<boolean> = new Subject<boolean>();
  networkStatus: Observable<boolean> = this._networkStatus.pipe(distinctUntilChanged());

  constructor(private logger: LoggerService) {
    this.logger.log('Connectivity constructor', MSRemoteLoggerCategory.CONNECTIVITY_SERVICE);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    Network.addListener('networkStatusChange', (status: ConnectionStatus) => {
      this._networkStatus.next(status.connected);
    });
  }

  async isOnline(): Promise<boolean> {
    return (await Network.getStatus()).connected;
  }
}
